import { useEffect, useState } from 'react';
import * as St from './index.styled';

/**
 * 페이지를 일정 이상 내리면 나타나는 '상단으로 이동' 플로팅 버튼.
 * 페이지(window) 스크롤 기준으로 동작한다.
 *
 * @param {object} props
 * @param {number} [props.threshold=300] 버튼이 나타나기 시작하는 스크롤 위치(px)
 * @param {string} [props.ariaLabel='상단으로 이동']
 */
export function ScrollToTopButton({
    threshold = 300,
    ariaLabel = '상단으로 이동'
}) {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        let ticking = false;

        const handleScroll = () => {
            // 스크롤 이벤트가 과도하게 들어오므로 프레임당 한 번만 계산
            if (ticking) {
                return;
            }
            ticking = true;
            window.requestAnimationFrame(() => {
                setVisible(window.scrollY > threshold);
                ticking = false;
            });
        };

        // 탭 전환 등으로 이미 스크롤된 상태에서 마운트될 수 있어 초기 1회 반영
        setVisible(window.scrollY > threshold);

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [threshold]);

    const handleScrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    return (
        <St.Container
            type='button'
            className={visible ? 'visible' : ''}
            aria-label={ariaLabel}
            aria-hidden={!visible}
            tabIndex={visible ? 0 : -1}
            onClick={() => handleScrollToTop()}
        >
            <span className='arrow'>↑</span>
        </St.Container>
    );
}
